import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Dialog, Spinner, useToast } from '@economic/taco';
import { t, useLocalization } from '../../../../shared/components/l10n/l10n';
import ConfirmationStart from './ConfirmationStart';
import internalApiClient from '../../../../shared/util/api/internalApiClient';

function RackbeatLagerOnboardingDialog() {
    const location = useLocation();
    const loadingTexts = useLocalization(textIds);
    const navigate = useNavigate();
    const open = location.hash === '#onboardRackbeatLager';
    const toast = useToast();
    const [isLoading, setIsLoading] = useState(false);

    function hide() {
        navigate(location.pathname);
    }

    function gotoRackbeatLagerPage() {
        navigate('/market/addon/rackbeatlager');
    }

    function completeOnBoarding() {
        setIsLoading(true);
        internalApiClient
            .post('rackbeat-lager/company/create-grant')
            .then((response: any) => {
                if (response.data) {
                    toast.success(t`RACKBEAT_LAGER_ONBOARDING_INSTALL_SUCCESS`);
                    window.open(response.data, '_blank');
                    gotoRackbeatLagerPage();
                } else {
                    toast.error(t`RACKBEAT_LAGER_ONBOARDING_INSTALL_ERROR`);
                }
            })
            .catch(() => {
                toast.error(t`RACKBEAT_LAGER_ONBOARDING_INSTALL_ERROR`);
            })
            .then(() => {
                setIsLoading(false);
            });
    }

    if (loadingTexts || isLoading) {
        return (
            <Dialog open={open} onClose={hide}>
                <Dialog.Content className="flex flex-col items-center" aria-label={t`TOAST_LOADING`}>
                    <Spinner />
                </Dialog.Content>
            </Dialog>
        );
    }

    return (
        <Dialog open={open} onClose={hide} closeOnEscape={false} size="sm">
            <Dialog.Content aria-label="rackbeatlager" className="rackbeatlager__onboarding">
                <ConfirmationStart onDone={completeOnBoarding} onCancel={hide} />
            </Dialog.Content>
        </Dialog>
    );
}

const textIds = [
    'TOAST_LOADING',
    'RACKBEAT_LAGER_ONBOARDING_CONFIRM_HEADER',
    'RACKBEAT_LAGER_ONBOARDING_CONFIRM_TEXT1',
    'RACKBEAT_LAGER_ONBOARDING_CONFIRM_TEXT2',
    'RACKBEAT_LAGER_ONBOARDING_CONFIRM_ACCEPT_BUTTON',
    'RACKBEAT_LAGER_ONBOARDING_CONFIRM_CANCEL_BUTTON',
    'RACKBEAT_LAGER_ONBOARDING_INSTALL_SUCCESS',
    'RACKBEAT_LAGER_ONBOARDING_INSTALL_ERROR',
    'RACKBEAT_LAGER_MARKET_ADDON_REMOVE_WARNING_TEXT',
];

export default RackbeatLagerOnboardingDialog;
